<div class="gutter hidex flx-col flx-gap-default" *ngIf="!started">
	<header class="flx-col">
			<h4 i18n>Kariera</h4>
			<h2 i18n>Pracuj z nami!</h2>
	</header>
	<div class="hidex bgwhite flx-dynamic flx-cntr-strt flx-gap-quadruple">
		<div class="w-50-md flx-col flx-cntr-strt flx-gap-default">
			<app-ve *ngIf="pageContent" [content]="pageContent"></app-ve>
			<button class="flat-button primary" (click)="startProcess()" i18n>Sprawdź kogo aktualnie poszukujemy</button>
		</div>
		<div class="w-50-md">
			<div class="box-16-9">
				<iframe src="https://www.youtube.com/embed/ZdWSgEKPorM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
			</div>
		</div>
	</div>
	<header class="flx-col">
		<h4>{{ pageName }}</h4>
		<h2 i18n>W liczbach</h2>
	</header>
	<div class="in_numbers_wrap gutter gutter-v-half">
		<div class=" flx-row flx-wrap-grid flx-btwn-cntr">
			<div class="in_numbers">
				<div><span>500</span>
					<p i18n>liczba pracowników</p>
				</div>
			</div>
			<div class="in_numbers">
				<div><span>250</span>
					<p i18n>liczba punktów sprzedaży</p>
				</div>
			</div>
			<div class="in_numbers">
				<div><span>47</span>
					<p i18n>w tylu krajach są nasze produkty</p>
				</div>
			</div>
			<div class="in_numbers">
				<div><span>150</span>
					<p i18n>modeli w ofercie</p>
				</div>
			</div>
			<div class="in_numbers">
				<div><span>50000</span>
					<p i18n>przyczep rocznie</p>
				</div>
			</div>
		</div>
	</div>
</div>


<section class="gutter form flx-col flx-cntr-cntr" *ngIf="form"> 

	<form [formGroup]="form" novalidate (submit)="submit()" class="steps w-100">
		<mat-vertical-stepper [linear]="isLinear" #stepper (selectionChange)="stepChange($event)">
			<mat-step id="step1" [completed]="selectedForm">
				<ng-template matStepperIcon="edit" let-index="index">{{index +1}}</ng-template>
				<ng-template matStepperIcon="done"><svg class="icon icon-check"><use xlink:href="#icon-check"></use></svg></ng-template>
				<ng-template matStepLabel>
					<h3 i18n>Aktualnie poszukujemy</h3>
					<h4 *ngIf="selectedForm">Wybrałaś/eś: {{ selectedForm.title }}</h4>
				</ng-template>

				<div class="flx-col flx-gap-default">

					<div *ngFor="let shop of formsSelected">
						<div class="offer flx-col flx-btwn-strtch">
							<div class="click-header flx-dynamic flx-gap-default flx-btwn-cntr" (click)="getAvailableDays(shop)">
								<h3>{{ shop.title }}</h3>
								<div class="flx-row flx-gap-default">
									<button type="button" class="flat-button primary">
										<span *ngIf="active != shop.id" i18n>DOWIEDZ SIĘ WIĘCEJ</span>
										<span *ngIf="active == shop.id" i18n="@@close">ZAMKNIJ</span>
									</button>
								</div>
							</div>
							<div class="hidex" *ngIf="active == shop.id">
								<div class="offer-content">
									<div class="flx-dynamic flx-gap-default">
										<div  *ngIf="shop.photos" class="w-25 flx-col">
											<app-image [url]="cdn +'/forms/'+ shop.photos_directory + '/' + shop.photos[0].filename"></app-image>
										</div>
										<div class="{{ (shop.photos ? 'w-25' : 'w-33') }} flx-col" *ngIf="shop.description">
											<!-- <h4 i18n>Zakres obowiązków</h4> -->
											<p [innerHtml]="shop.description"></p>
										</div>
										<div class="{{ (shop.photos ? 'w-25' : 'w-33') }} flx-col" *ngIf="shop.extra_1">
											<!-- <h4 i18n>Wymagania</h4> -->
											<p [innerHtml]="shop.extra_1"></p>
										</div>
										<div class="{{ (shop.photos ? 'w-25' : 'w-33') }} flx-col" *ngIf="shop.extra_2">
											<!-- <h4 i18n>Oferujemy</h4> -->
											<p [innerHtml]="shop.extra_2"></p>
										</div>
									</div>
									<h3 i18n>Aplikuj na</h3>
									<input type="hidden" formControlName="id_form">
									<div class="step-data flx-dynamic flx-gap-double">
										<div class="form-wrap" class="w-50-md">
											<h4 i18n>Uzupełnij formularz</h4>
											<mat-form-field appearance="outline" class="w-100">
												<mat-label i18n="@@namesurname">Imię i nazwisko</mat-label>
												<input matInput formControlName="name" i18n-placeholder>
												<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
											</mat-form-field>
											<div class="flx-dynamic flx-gap-default flx-cntr-cntr">
												<mat-form-field appearance="outline" class="w-100">
													<mat-label i18n="@@email">Adres e-mail</mat-label>
													<input matInput formControlName="email" i18n-placeholder>
													<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
												</mat-form-field>
												<mat-form-field appearance="outline" class="w-100">
													<mat-label i18n="@@client_phone">Telefon</mat-label>
													<input matInput formControlName="phone" i18n-placeholder>
													<mat-error i18n *ngIf="form.get('country').value == 'PL'">To pole jest wymagane - format
														555444333</mat-error>
													<mat-error i18n *ngIf="form.get('country').value != 'PL'">To pole jest wymagane</mat-error>
												</mat-form-field>
												<!-- <mat-form-field appearance="outline" class="w-100">
													<mat-label i18n="@@country">Kraj pochodzenia</mat-label>
													<mat-select formControlName="country">
														<mat-option *ngFor="let country of countries" [value]="country.value">
															{{ country.viewValue }}
														</mat-option>
													</mat-select>
													<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
												</mat-form-field> -->
											</div>
											<mat-form-field appearance="outline" class="w-100">
												<mat-label i18n>Dodatkowe uwagi?</mat-label>
												<textarea matInput formControlName="comment"></textarea>
											</mat-form-field>

											<div id="uploader" class="flx-row flx-gap-default flx-strt-strtch">

											<p class="infobox success" *ngIf="uploaded.length > 0">
												<ng-container i18n>Następujące pliki zostały dodane do zgłoszenia</ng-container>:<br>
												<span *ngFor="let item of uploaded">{{ item }}<br></span>
											</p>
											
											<p class="infobox error" *ngIf="errored.length > 0">
												<ng-container i18n>Następujące pliki nie zostały dodane do zgłoszenia, wystąpił nieoczekiwany błąd</ng-container>:<br>
												<span *ngFor="let item of errored">{{ item.name }} {{ item.error }}<br></span>
												<ng-container i18n>Spróbuj jeszcze raz.</ng-container>
											</p>

											<div *ngIf="attachments.length == 0" ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (onFileDrop)="fileDropped($event)"  [uploader]="uploader" class="drop-zone flx-col flx-cntr-cntr">
												<div *ngIf="loading_file" class="loader-circle"></div>
												<div *ngIf="!loading_file">
													<span i18n>DODAJ SWOJE CV PRZECIĄGAJĄC JE TUTAJ LUB </span> <label class="fileselect" for="file">WYBIERZ Z DYSKU</label><input id="file" class="inputfile" type="file" ng2FileSelect (onFileSelected)="fileDropped($event)" [uploader]="uploader" multiple>
												</div>
											</div>
											</div>

											<div class="rodo-checkbox w-100"
												[class.error]="form.controls.rodo.invalid && form.controls.rodo.dirty">
												<mat-checkbox formControlName="rodo" i18n>Wyrażam zgodę na przetwarzenie swoich danych osobowych.</mat-checkbox>
												<mat-error *ngIf="form.controls.rodo.invalid && form.controls.rodo.dirty" i18n>Musisz wyrazić
													zgodę na przetwarzenie swoich danych osobowych.</mat-error>
											</div>
											<p class="infobox error" *ngIf="res === 3" i18n>Zgłoszenie na podany adres email już istnieje - poczekaj na naszą odpowiedź, skontaktujemy się z Tobą najszybciej jak to będzie możliwe.</p>
											<p class="infobox error" *ngIf="res === 2" i18n>Coś się nie udało - spróbuj jeszcze raz.</p>
											<p class="infobox success" *ngIf="res === 1" i18n>Dziękujemy za zgłoszenie.</p>
											<button class="flat-button primary w-100 fat" type="submit" [disabled]="sent || res === 3" i18n>WYŚLIJ APLIKACJĘ</button>
										</div>
										<div class="clause-wrap"  class="w-50-md">
											<h4 i18n>W CV prosimy o dołączenie klauzuli zgody na przetwarzanie danych osobowych:</h4>
											<p #clause i18n>Wyrażam zgodę na przetwarzanie moich danych osobowych dla potrzeb niezbędnych do realizacji procesu rekrutacji (zgodnie z ustawą z dnia 10 maja 2018 roku o ochronie danych osobowych (Dz. Ustaw z 2018, poz. 1000) oraz zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO). Administratorem Twoich danych osobowych będzie Temared Spółka z ograniczoną odpowiedzialnością siedzibą w Świdniku (Al. Lotników Polskich 1, 21-040 Świdnik).</p><br>
											<button type="button" class="stroked-button w-100" (click)="copyInputMessage(clause)" i18n>Skopiuj klauzulę do schowka</button>
										</div>
									</div>
								</div>
								
							</div>
						</div>
					</div>
				</div>
			</mat-step>
			<mat-step id="step2">
				<ng-template matStepLabel><h3 i18n>Podsumowanie</h3></ng-template>
				<div class="w-100 text-center gutter gutter-v" *ngIf="selectedForm">
					<h1 i18n>Dziękujemy za aplikację.</h1>
				</div>
			</mat-step>
		
		</mat-vertical-stepper>
		</form>	
</section>

<div class="gutter hidex flx-col flx-gap-default">
	<header class="flx-col">
	<h4 i18n="@@carier1">Korzyści</h4>
	<h2 i18n="@@carier2">Z pracy w TEMARED</h2>
	</header>
	<div class="in_numbers_wrap gutter gutter-v-half">
		<div class="flx-row flx-wrap-grid flx-btwn-cntr">
		<div class="in_numbers">
			<div><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
						d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z">
					</path>
				</svg>
				<p i18n="@@carier3">Opieka medyczna</p>
			</div>
		</div>
		<div class="in_numbers">
			<div><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
						d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z">
					</path>
				</svg>
				<p i18n="@@carier4">Karta sportowa</p>
			</div>
		</div>
		<div class="in_numbers">
			<div><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
						d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z">
					</path>
				</svg>
				<p i18n="@@carier5">Ubezpieczenie grupowe</p>
			</div>
		</div>
		<div class="in_numbers">
			<div><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
						d="M8 13v-1m4 1v-3m4 3V8M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z">
					</path>
				</svg>
				<p i18n="@@carier6">Szkolenia</p>
			</div>
		</div>
		<div class="in_numbers">
			<div><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
						d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z">
					</path>
				</svg>
				<p i18n="@@carier7">Możliwość awansu</p>
			</div>
		</div>
		<div class="in_numbers">
			<div><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
						d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z">
					</path>
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
						d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
				</svg>
				<p i18n="@@carier8">Wsparcie podczas wdrożenia</p>
			</div>
		</div>
	</div>
	</div>



	<div class="flx-dynamic flx-cntr-strt flx-gap-quadruple">
		<div class="w-50-md flx-col  flx-gap-default">
			<header class="flx-col">
				<h4 i18n="@@carier9">Proces</h4>
				<h2 i18n="@@carier10">Rekrutacji</h2>
			</header>
			<div class="steps">
				<ul>
					<li class="step step-1">
						<span><strong i18n="@@carier11">Krok 1</strong><br /><ng-container i18n="@@carier17">Aplikujesz</ng-container></span>
					</li>
					<li class="step step-2">
						<span><strong i18n="@@carier12">Krok 2</strong><br /><ng-container i18n="@@carier18">Spotykamy się na rozmowie</ng-container></span>
					</li>
					<li class="step step-3">
						<span><strong i18n="@@carier13">Krok 3</strong><br /><ng-container i18n="@@carier19">Otrzymujesz informację zwrotną (tak/nie)</ng-container></span>
					</li>
					<li class="step step-4">
						<span><strong i18n="@@carier14">Krok 4</strong><br /><ng-container i18n="@@carier20">Dołączasz do zespołu</ng-container></span>
					</li>
				</ul>
			</div>
		</div>
		<div class="w-50-md">
			<header class="flx-col">
				<h4 i18n="@@carier15">Zobacz</h4>
				<h2 i18n="@@carier16">Jak się u nas pracuje</h2>
			</header>
			<div class="overflow-hidden career-slider-wrap">

				<swiper #swiper [slidesPerView]="1" [spaceBetween]="0" [navigation]="true">
					<ng-template swiperSlide *ngFor="let slide of gallery; let i = index">					
							<picture>
								<img [src]="slide.path">
							</picture>
							<ng-container *ngIf="slide.title !== slide.alt">
								<p class="photo-description">{{ slide.title }}</p>
							</ng-container>
					</ng-template>
				</swiper>

			</div>
		</div>
	</div>
</div>

<div class="gutter">
<div class="regulations">
	<ng-container i18n="@@carier21">Klauzula informacyjna dotycząca przetwarzania danych osobowych kandydata do pracy</ng-container><span (click)="regulations = !regulations" i18n>...czytaj więcej</span>
	<div class="regulations-content" *ngIf="regulations">
		Realizując obowiązek z art. 13 ust. 1 i 2 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) (Dz.U.UE.L.2016.119.1) (dalej jako: „RODO”) informujemy, że:

1. Administratorem, czyli podmiotem decydującym o celach i sposobach przetwarzania Pani/Pana danych osobowych przekazywanych w składanych dokumentach aplikacyjnych będzie Temared Spółka z ograniczoną odpowiedzialnością z siedzibą w Świdniku (adres Spółki: Al. Lotników Polskich 1, 20-041 Świdnik) (dalej jako: „My” lub „Pracodawca”).<br>
2. W sprawach dotyczących ochrony danych osobowych można kontaktować się z nami poprzez pocztę tradycyjną pisząc na w/w adres Pracodawcy.<br>
3. Pracodawca będzie przetwarzał Pani/Pana dane osobowe w celu realizacji procesu rekrutacji, a w szczególności w celu oceny Pani/Pana kwalifikacji, zdolności i umiejętności potrzebnych do pracy na stanowisku, na które Pani/Pan aplikuje. Przetwarzanie Pani/Pana danych osobowych: 1) w zakresie danych wymienionych w art. 221 § 1 kodeksu pracy, jest niezbędne do wypełnienia ciążących na nas obowiązków prawnych, wynikających z przepisów kodeksu pracy i wydanych na ich podstawie przepisów wykonawczych, co znajduje podstawę prawną w art. 6 ust. 1 lit. c) RODO; 2) innych niż wymienione w art. 221 § 1 kodeksu pracy, o ile takie dane zostaną nam przekazane, realizowane będzie na podstawie Pani/Pana zgody na przetwarzanie danych osobowych, co znajduje podstawę prawną w art. 6 ust. 1 lit. a) RODO; 3) jest niezbędne do podjęcia przez nas działań na Pani/Pana żądanie przed zawarciem ewentualnej umowy o pracę, co znajduje podstawę prawną w art. 6 ust. 1 lit. b) RODO. 4. Pani/Pana dane osobowe nie będą nikomu ujawniane. Dostęp do danych będzie miał jedynie ograniczony krąg naszych pracowników odpowiedzialnych za rekrutację. Odbiorcą Pani/Pana danych mogą być podmioty, z usług których korzystamy zlecając im realizację zadań łączących się z koniecznością przetwarzania danych osobowych. Takim podmiotem będzie np. firma świadcząca dla nas usługi hostingu danych i poczty e-mail.<br>
<br>5. Pracodawca nie przekazuje przetwarzanych danych osobowych do jakiegokolwiek państwa poza Europejskim Obszarem Gospodarczym (obejmującym kraje Unii Europejskiej, Norwegię, Liechtenstein i Islandię) lub do jakiejkolwiek organizacji międzynarodowej.
<br>6. Pani/Pana dane osobowe będą przechowywane przez czas w jakim istniał będzie cel przetwarzania, a więc realizowany będzie proces rekrutacji. Proces taki zazwyczaj trwa ok. 3 miesięcy. Jeżeli wyrazi Pani/Pan dodatkową zgodę na przetwarzanie danych osobowych na potrzeby przyszłych rekrutacji, Pani/Pana dane będą przez nas przechowywane w bazie kandydatów do pracy przez okres 12 miesięcy.
<br>7. Przysługują Pani/Panu następujące prawa: 1) prawo żądania dostępu do swoich danych osobowych; 2) prawo żądania sprostowania danych osobowych, gdy dane są nieprawidłowe, a także prawo żądania uzupełnienia danych, gdy dane są niekompletne; 3) prawo żądania usunięcia danych osobowych, o ile zachodzi uzasadniająca to żądanie okoliczność przewidziana w przepisach prawa (tj. w art. 17 RODO); 4) prawo żądania ograniczenia przetwarzania danych osobowych, w przypadkach przewidzianych prawem (tj. art. 18 RODO); 5) prawo przenoszenia danych.
<br>8. Jeżeli przetwarzanie Pani/Pana danych osobowych odbywa się na podstawie zgody, ma Pani/Pan prawo cofnięcia tej zgody w dowolnym momencie. Cofnięcie zgody nie będzie jednak miało wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej cofnięciem.
<br>9. Ma Pani/Pan również prawo do wniesienia skargi do organu nadzorczego – Prezesa Urzędu Ochrony Danych Osobowych (ul. Stawki 2; 00-193 Warszawa), jeżeli uzna Pani/Pan, że przetwarzanie danych osobowych realizowane przez Pracodawcę narusza przepisy RODO.
<br>10. Podanie danych osobowych jest całkowicie dobrowolne, aczkolwiek niepodanie danych wymienionych w art. 221 § 1 kodeksu pracy spowoduje niemożność wzięcia udziału w prowadzonej przez nas rekrutacji.
<br>11. Pani/Pana dane osobowe nie będą przez nas przetwarzane w sposób, który skutkowałby zautomatyzowanym podejmowaniem decyzji, w tym profilowaniem. Nie wykorzystujemy systemów informatycznych, które gromadziłyby informacje na Pani/Pana temat, a następnie samodzielnie, automatycznie, podejmowałyby decyzje, które mogłyby wywołać wobec Pani/Pana skutki prawne lub w podobny sposób istotnie na Panią/Pana wpływać.
	</div>
</div>
</div>